import axios from 'axios';

export const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('talyer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resilience for spotty connections / brief backend restarts:
// retry requests that failed with a network error (no HTTP response) up to 2 times.
api.interceptors.response.use(undefined, async (error) => {
  const config = error.config || {};
  const isNetworkError = !error.response;
  config.__retryCount = config.__retryCount || 0;
  if (isNetworkError && config.__retryCount < 2) {
    config.__retryCount += 1;
    await new Promise((r) => setTimeout(r, 1200 * config.__retryCount));
    return api(config);
  }
  return Promise.reject(error);
});

// Extract a friendly message from any API error
export function errMsg(e) {
  if (!e?.response) {
    return 'Cannot reach the server right now. Please check your internet connection and try again in a moment.';
  }
  const d = e.response.data?.detail;
  if (!d) return 'Something went wrong. Please try again.';
  if (typeof d === 'string') return d;
  if (d.message) return d.message;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return 'Something went wrong. Please try again.';
}

export function isUpgradeErr(e) {
  const d = e?.response?.data?.detail;
  return d && typeof d === 'object' && d.code === 'plan_upgrade_required';
}

export function fileUrl(path) {
  if (!path) return null;
  return path.startsWith('http') ? path : `${BACKEND}${path}`;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      return true;
    } catch {
      return false;
    } finally {
      document.body.removeChild(ta);
    }
  }
}
